import { Component, Prop, Listen, Event, EventEmitter, Element, h } from '@stencil/core';
import "../../../ionic/ionic.module";
import { ExpanderEvent } from './../ibl-expander/expander.model';
import { AccordionEvent } from './ibl-accordion.model';
import { IblExpander } from '../ibl-expander/ibl-expander';

@Component({
  tag: 'ibl-accordion',
  styleUrl: 'ibl-accordion.css',
  styles: 'overflow: hidden',
  shadow: false,
})
export class IblAccordion {
  @Element() hostElement: HTMLElement;

  @Prop() multiple: boolean;

  @Listen('expanderOpen') expanderOpen(e: CustomEvent<ExpanderEvent>) {
    if (!this.multiple) {
      this.closeExpanders.emit({
        sender: this,
        exclude: e.detail.sender,
      });
      // console.log(e.detail.sender.hostElement);

      // console.log( (Object.values(this.hostElement.children))
      //   .filter(val => val ));
      (Object.values(this.hostElement.children) as any as IblExpander[])
        .filter(val => val && val.close)
        .forEach(val => {
          // console.log(e.detail.sender, val);
          if ((val !== e.detail.sender.hostElement as any as IblExpander)) {
            val.close();
          }
        });
    }
  }

  @Event() closeExpanders: EventEmitter<AccordionEvent>;

  render() {
    return (
      <slot></slot>
    );
  }
}
